/**
 * usePhase · thin wrapper around useCompanyMode exposing the rollout phase.
 *
 * Phase 1 (Bruno / new dispatchers): dashboard_mode === "audit"
 *   Surfaces only Overview + Compliance & Intelligence + Settings.
 *
 * Phase 2 (test/live): dashboard_mode === "full" | "deals" | "agents" | "custom"
 *   All advanced features (load board, dispatch, fleet, trust links, rate intel).
 *
 * Flipping a tenant from Phase 1 to Phase 2 is a single
 * `companies.settings.dashboard_mode` update · no code deploy.
 */
import { useCompanyMode } from "@/hooks/useCompanyMode";

export type Phase = "phase1" | "phase2";

export function usePhase() {
  const { dashboardMode, setDashboardMode } = useCompanyMode();
  const phase: Phase = dashboardMode === "audit" ? "phase1" : "phase2";

  return {
    phase,
    dashboardMode,
    isPhase1: phase === "phase1",
    isPhase2: phase === "phase2",
    setDashboardMode,
  };
}
